<template>
  <sl-page>
    <input type="file" id="j_file" ref="uploadfile" name="file" style="opacity:0;position: absolute;pointer-events:none;" />
    <Form ref="form" :model="form" :rules="rules">
      <FormItem prop="url">
        <Input v-model="form.url" size="large">
        <Select v-model="form.method" slot="prepend" style="width: 80px">
          <Option value="get">GET</Option>
          <Option value="post">POST</Option>
          <Option value="put">PUT</Option>
          <Option value="delete">DELETE</Option>
          <Option value="file">FILE</Option>
        </Select>
        <div slot="append" style="display: flex;">
          <Select placeholder="responseType" v-model="form.responseType">
            <Option value="json">JSON</Option>
            <Option value="blob">BLOB</Option>
          </Select>
          <Button type="primary" @click="handleSubmit('form')">发送</Button>
        </div>
        
        </Input>
      </FormItem>
      <FormItem>
        <Input v-model="form.params" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="参数 JSON 格式"></Input>
      </FormItem>
    </Form>
    <div class="result">
      <Tabs>
        <TabPane label="Response">
          <div class="code">
            <vue-json-pretty :data="request.result"></vue-json-pretty>
          </div>
        </TabPane>
        <TabPane label="Headers">
          <vue-json-pretty :data="request.headers"></vue-json-pretty>
        </TabPane>
        <!-- <TabPane label="Request Headers">
          <vue-json-pretty :data="request.reqHeaders"></vue-json-pretty>
        </TabPane>
        <TabPane label="Response Headers">
          <vue-json-pretty :data="request.resHeaders"></vue-json-pretty>
        </TabPane> -->
      </Tabs>
    </div>
  </sl-page>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty'
import { saveFile } from '@/util'
export default {
  components: {
    VueJsonPretty
  },
  data() {
    const validateParams = (rule, value, callback) => {

      try {
        eval('(' + value + ')')
      } catch (e) {
        callback(new Error('必须是JSON格式'));
      }
    }
    return {
      form: {
        method: 'post',
        url: '',
        params: '',
        responseType:'json',
      },
      rules: {
        url: [
          { required: true, message: '请输入url', trigger: 'blur' },
        ],
        params: [
          { validator: validateParams, trigger: 'blur' },
        ]
      },
      request: {
        process: false,
        result: {},
        headers:{},
        reqHeaders:{},
        resHeaders:{}
      }
    }
  },
  methods: {
    handleSubmit(name) {

      this.$refs[name].validate((valid) => {
        if (valid) {
          let { responseType , method , params , url } = this.form
          params = params ? eval('(' + params + ')') : {}
          
          // console.log(this.$request[form.method])
          this.request.running = true
          let options = { responseType , raw:true}
          this.$request[method](url, params, options).then(resp => {
            // this.request.running = false
            if( responseType == 'blob' ){
              saveFile(resp)
            }else{
              this.request.result = resp.data
            }
            this.request.reqHeaders = resp.config.headers
            this.request.resHeaders = resp.headers
            this.request.headers = {
              'General':{
                'Request URL': resp.config.url,
                'Request Method': resp.config.method,
                'Status Code': resp.status,
              },
              'Request Headers':resp.config.headers,
              'Response Headers':resp.headers
            }
          })
        } else {
          this.$Message.error('检查参数')
        }
      })
    },
    handleChange(val){
      //console.log(this.$refs.uploadfile.length)
      // this.$refs.uploadfile.click()
      //document.getElementById('j_file').click()
      // console.log(document.getElementById('j_file').click())
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
}

</script>
<style lang="scss">
.result {
  min-height: 350px;
  background: #f7f7f7;
  border-color: #f1f1f1;
  .code{
    padding:12px;
  }
  .ivu-tabs-bar{
    background:#fff;
  }
  .vjs__tree{
    font-size:13px;
  }
}

</style>
